let audio: AudioContext | null = null;

export function tocarSom() {
  try {
    audio ??= new AudioContext();
    const agora = audio.currentTime;
    [0, 0.14].forEach((atraso, i) => {
      const osc = audio!.createOscillator();
      const ganho = audio!.createGain();
      osc.frequency.value = i === 0 ? 880 : 1175;
      ganho.gain.setValueAtTime(0.0001, agora + atraso);
      ganho.gain.exponentialRampToValueAtTime(0.15, agora + atraso + 0.01);
      ganho.gain.exponentialRampToValueAtTime(0.0001, agora + atraso + 0.12);
      osc.connect(ganho).connect(audio!.destination);
      osc.start(agora + atraso);
      osc.stop(agora + atraso + 0.13);
    });
  } catch {}
}

export function permissaoNotificacao(): NotificationPermission | 'indisponivel' {
  return 'Notification' in window ? Notification.permission : 'indisponivel';
}

export async function pedirPermissao(): Promise<void> {
  if ('Notification' in window && Notification.permission === 'default')
    await Notification.requestPermission();
}

export function notificar(titulo: string, corpo: string, aoClicar?: () => void) {
  tocarSom();
  if (!('Notification' in window) || Notification.permission !== 'granted' || document.hasFocus())
    return;
  const n = new Notification(titulo, { body: corpo, icon: '/favicon.svg', tag: titulo });
  n.onclick = () => {
    window.focus();
    aoClicar?.();
    n.close();
  };
}
